<h2 *ngIf="data?.existingName" mat-dialog-title>Edit</h2>
<h2 *ngIf="!data?.existingName" mat-dialog-title>Add</h2>
<form [formGroup]="renameForm" (ngSubmit)="onRename()">
  <mat-dialog-content>
    <p *ngIf="data?.existingName">Current name: {{ data.existingName }}</p>
    <mat-form-field appearance="fill">
      <mat-label *ngIf="data?.existingName">New name</mat-label>
      <mat-label *ngIf="!data?.existingName">Name</mat-label>
      <input matInput formControlName="newName">
      <mat-error *ngIf="renameForm.get('newName')?.hasError('required')">New name is required</mat-error>
      <mat-error *ngIf="renameForm.get('newName')?.hasError('sameAsExisting')">New name must be different from the existing name</mat-error>
    </mat-form-field>
  </mat-dialog-content>
  <mat-dialog-actions align="end">
    <button mat-button [mat-dialog-close]="undefined">Cancel</button>
    <button *ngIf="data?.existingName" mat-flat-button color="primary" [disabled]="renameForm.invalid" (click)="onRename()">Edit</button>
    <button *ngIf="!data?.existingName" mat-flat-button color="primary" [disabled]="renameForm.invalid" (click)="onRename()">Add</button>
  </mat-dialog-actions>
</form>
